import { loadableWithFallback } from '@vision/ui/utils';
import type { TreeMapChart2Props } from './TreeMapChart2';

export const TreeMapChart2 = loadableWithFallback<TreeMapChart2Props>(() => import('./TreeMapChart2'));
